import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { ArrayUtil } from 'kuaidong-lib'
import { CacheBustImg } from 'kuaidong-component'
import { IPayOnBehalfOfInfo } from 'kuaidong-model'

import IconSplus from '../images/icon_splus@2x.png'
import IconSSplus from '../images/icon_ssplus@2x.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'PayOnBehalfOfPoster',
  props: {
    info: null,
    bgImg: null,
    qrcodeUrl: null
  },
  setup(__props: any) {

const props = __props as { info: IPayOnBehalfOfInfo; bgImg?: string; qrcodeUrl: string };

const items = [
  {
    type: 'SPLUS_VIP',
    name: '运动会员',
    icon: IconSplus,
  },
  {
    type: 'SPLUS_PRO',
    name: '运动大会员',
    icon: IconSSplus,
  },
  {
    type: 'SPLUS_PRO_PACKAGE',
    name: '运动大会员',
    icon: IconSSplus,
  },
]

const itemMap = ArrayUtil.buildMapByKey(items, 'type')



const config = computed(() => itemMap[props.info.product_sn || ''])

return { __sfc: true,items, itemMap, props, config, CacheBustImg }
}

})